import { openWindow } from 'js/utils/url.util';

export * from 'js/utils/url.util';

/**
 * Check is url for external page
 * @param  {String | Object}  path
 * @return {Boolean}
 */
export const isExternalUrl = (path) => {
    const url = typeof path === 'string' ? path : path?.pathname || '';
    const [, protocol, host, link] = url.match(/^([^:/?#]+:)?(?:\/\/([^/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);

    if (typeof protocol === 'string' && protocol.length > 0 && protocol.toLowerCase() !== location.protocol) {
        return true;
    }

    if (
        typeof host === 'string'
        && host.length > 0
        && host.replace(new RegExp(`:(${location.protocol === 'https' ? 443 : 80})?$`), '') !== location.host
    ) {
        return true;
    }

    // Checking reverse proxy path to count as external for us: */club/*
    return /\/club\/[\s\S]*/g.test(link) || link?.includes('club-upgrade.html') || link?.includes('club-wifi.html');
};

/**
 * Wrapper for window.open() that open new window by default.
 * @param {String} [url]
 * @param {String} [name]
 * @param {String} [features]
 * @returns {*}
 */
export const openNewWindow = (url, name, features = 'resizable=yes, width=1366px, height=768px') =>
    openWindow(url, name, features);
